var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg8Mobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 407,
    viewBox: "0 0 360 407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_447_95439)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.955,
    cy: 230.5,
    rx: 158.955,
    ry: 230.5,
    transform: "matrix(0.810786 0.585342 -0.799372 0.600837 272.5 231.928)",
    fill: "url(#paint0_linear_447_95439)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_447_95439)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.955,
    cy: 230.5,
    rx: 158.955,
    ry: 230.5,
    transform: "matrix(0.810786 0.585342 -0.799372 0.600837 355.312 86)",
    fill: "url(#paint1_linear_447_95439)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_447_95439",
    x: -157.75,
    y: 146.602,
    width: 749.75,
    height: 633.725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_447_95439"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_447_95439",
    x: -74.9375,
    y: 0.673828,
    width: 749.75,
    height: 633.725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_447_95439"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_447_95439",
    x1: 158.955,
    y1: 0,
    x2: 158.955,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22D695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D695",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_447_95439",
    x1: 158.955,
    y1: 0,
    x2: 158.955,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434BEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434BEE",
    stopOpacity: 0.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg8Mobile);
export default __webpack_public_path__ + "static/media/bg8-mobile.7e8e893793347596effe647f465f082f.svg";
export { ForwardRef as ReactComponent };